import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { setApiTokenProvider } from './community-hats-js-library/back-end/router';
import { getApiToken } from './utils/apiTokenFunctions';


// The router calls the application server directly and needs a token to do it,
// but it lives in the library and must not import the app's store. Hand it a
// way to obtain one instead.
setApiTokenProvider(getApiToken);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
